import { Badge, Box } from '@chakra-ui/react'
import { EncounterType } from '@hb/shared'
import { FC } from 'react'
import { EncounterTypeHeaderContentProps } from '../types'

export const UltrasoundExamHeaderContent: FC<
  EncounterTypeHeaderContentProps<EncounterType.ULTRASOUND>
> = ({ config }) => {
  if (!config) return null
  return (
    <Box>
      <Badge fontSize="sm" colorScheme="blue" fontWeight={500} fontFamily="Hero-New">
        {config.scenarioType === 'sonographer-study' ? 'Sonographer Study' : 'Provider POCUS'}
      </Badge>
    </Box>
  )
}
